"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
exports.getTags = (keyword) => (dispatch, getState) => {
    dispatch({ type: 'FETCH_TAGS_REQUEST' });
    const query = graphql_tag_1.default `
            query CampaignTags($keyword: String!) {
                campaignTags(keyword: $keyword)
            }
        `;
    const request = {
        query,
        variables: {
            keyword: keyword === null ? '' : keyword,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_TAGS_FAILURE', dispatch, errors[0].message);
        }
        else {
            return dispatch({
                type: 'FETCH_TAGS_SUCCESS',
                tags: data.campaignTags,
            });
        }
    }, ({ result }) => handleError_1.default('FETCH_TAGS_FAILURE', dispatch, result.errors[0].message));
};
